// Use this as a way to handle global events anywhere in the app

import Vue from "vue";
export const EventBus = new Vue();